export const environment = {
  production: false,
  apiURL: "https://cgosdevukservices.sequation.net/",
  logo: `./assets/logo/storeGene_text.png`,
  appTitle: 'StoreGene',
  
   azureBlobStorage: ''
  
};
